const config = {
  API_URL: process.env.REACT_APP_API_URL || '/api',
  
  // Punjab Branch Configuration
  BRANCH_ID: 'PB001',
  BRANCH_NAME: 'Punjab Branch',
  BRANCH_CODE: 'PB001'
};
 
export default config; 